import { createSlice } from "@reduxjs/toolkit";

import { RootState, NotificationPreferencesState } from "@/types/store";
import {
  getNotificationPreferences,
  updateNotificationPreferences,
} from "@/api/notificationPreferences/thunks";

const initialState: NotificationPreferencesState = {
  preferences: [],
  loading: false,
  saving: false,
  error: null,
};

export const NotificationPreferencesSlice = createSlice({
  name: "NotificationPreferencesSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getNotificationPreferences.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getNotificationPreferences.fulfilled, (state, action) => {
        state.loading = false;
        state.preferences = action.payload;
      })
      .addCase(getNotificationPreferences.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || null;
      });

    builder
      .addCase(updateNotificationPreferences.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(updateNotificationPreferences.fulfilled, (state, action) => {
        state.saving = false;
        // The PUT returns the re-fetched, server-resolved list — this becomes
        // the new "last-saved" snapshot the page diffs its draft against.
        state.preferences = action.payload;
      })
      .addCase(updateNotificationPreferences.rejected, (state, action) => {
        state.saving = false;
        state.error = (action.payload as string) || null;
      });
  },
});

export const selectNotificationPreferences = (state: RootState) =>
  state.NotificationPreferences.preferences;
export const selectNotificationPreferencesLoading = (state: RootState) =>
  state.NotificationPreferences.loading;
export const selectNotificationPreferencesSaving = (state: RootState) =>
  state.NotificationPreferences.saving;
export const selectNotificationPreferencesError = (state: RootState) =>
  state.NotificationPreferences.error;

export default NotificationPreferencesSlice.reducer;
